var tooltipXPosition = chart => {
  // @ts-expect-error none of this appears to match up with highcharts
  var {
    options,
    spacingBox
  } = chart;
  var {
    legend: legendOptions
  } = options;
  // @ts-expect-error none of this appears to match up with highcharts
  var {
    legendWidth
  } = chart.legend;
  var optionsX = chart.legend.options.x || 0;
  var hasVerticalLegend = (legendOptions === null || legendOptions === void 0 ? void 0 : legendOptions.layout) === 'vertical' && legendOptions.align === 'right';
  return hasVerticalLegend ? spacingBox.width - legendWidth + optionsX + 9 : spacingBox.width - 10;
};
export default tooltipXPosition;